import { createContext, useContext } from "react";
import type { ContentValidateBundle } from "../hooks/useContentValidateBundle";

/**
 * Holds the published content `validate` rules (keyed by field internalName)
 * for the current job type, so FieldInput can evaluate its field's rule
 * client-side on blur. Default is an empty bundle — a component rendered
 * without a provider simply has no content traps.
 */
export const ContentValidateContext = createContext<ContentValidateBundle>({});

export function useContentValidateRules(): ContentValidateBundle {
  return useContext(ContentValidateContext);
}
